import React from "react"
import CCMEditMain from "./component/CCMEditMain/CCMEditMain"

const CCMEditCare = () => <CCMEditMain />

export default CCMEditCare
